module.exports = __webpack_public_path__ + "static/media/OSSpeising.3665ec95.png";